import { Button, Flex, Group, Paper, Text } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { DeleteButton } from '@/core/components';

import { formatDate, useDelete } from '@feature/utils';

import { useLegalHolidayDelete } from '../model/LegalHolidayQuery';
import { LegalHoliday } from '../model/LegalHolidayTypes';

interface LegalHolidayRowProps {
  legalHoliday: LegalHoliday;
  onEdit: (legalHoliday: LegalHoliday) => void;
}

export function LegalHolidayRow({ legalHoliday, onEdit }: LegalHolidayRowProps) {
  const { t } = useTranslation();
  const mutation = useLegalHolidayDelete(legalHoliday.id);
  const deleteProps = useDelete({ mutation, navigateTo: null });

  return (
    <Paper
      p="sm"
      role="group"
      aria-label={`${formatDate(legalHoliday.date)} ${legalHoliday.name}`}
    >
      <Flex
        justify="space-between"
        align="center"
      >
        <Group gap="md">
          <Text
            size="sm"
            fw="500"
          >
            {formatDate(legalHoliday.date)}
          </Text>
          <Text size="sm">{legalHoliday.name}</Text>
        </Group>
        <Group gap="xs">
          <Button
            size="xs"
            variant="outline"
            leftSection={<IconPencil size={14} />}
            onClick={() => onEdit(legalHoliday)}
          >
            {t('button.edit')}
          </Button>
          <DeleteButton
            size="xs"
            {...deleteProps}
          />
        </Group>
      </Flex>
    </Paper>
  );
}
